import UserService from "../../../../services/UserService";
import OwLabel from "../../../shared/OwLabel/OwLabel";

type Props = {
    startDate?: string | null;
    endDate?: string | null;
    className?: string;
};

export const ReportPeriod = (props: Props) => {
    if (!props.startDate && !props.endDate) {
        return null;
    }

    return (
        <div className={props.className ?? "mb-5"}>
            <b>
                <OwLabel className={"me-2"} title={"report_period"} />
            </b>
            <span>
                {UserService.parseUTCDate(props.startDate)} - {UserService.parseUTCDate(props.endDate)}
            </span>
        </div>
    );
};

export default ReportPeriod;
